export default __webpack_public_path__ + "files/eb9c9ed586eda5e79e4287b3da551d6d.png";